// extracted by mini-css-extract-plugin
export default {"container":"PlanejamentoBody_container__k3+C2","square":"PlanejamentoBody_square__wU3Zu"};